import ComponentBase from '../base/component-base';
import { EVENT_GLOBAL_UPDATE_CART } from '../../constants/event';

/**
 * Cart Icon Component
 * Updates the cart item count display when cart changes
 * Multiple instances can exist on the page (header, mobile nav, etc.)
 */
class CartIcon extends ComponentBase {
  private countElement: HTMLElement | null = null;
  private onUpdateCartBinding: (e: Event) => void;

  constructor(element: HTMLElement) {
    super(element);

    console.log('[CartIcon] Initializing cart icon:', element);

    // Bind event handlers
    this.onUpdateCartBinding = this.onUpdateCart.bind(this);

    this.init();
  }

  protected init(): void {
    // Find the count element
    this.countElement = this.element.querySelector('.c-global-cart-icon__count');

    if (!this.countElement) {
      console.warn('[CartIcon] Count element not found', this.element);
      return;
    }

    console.log('[CartIcon] Count element found:', this.countElement);

    // Add event listener for cart updates
    document.addEventListener(EVENT_GLOBAL_UPDATE_CART, this.onUpdateCartBinding);

    console.log('[CartIcon] Event listener attached');
  }

  private onUpdateCart(e: Event): void {
    const customEvent = e as CustomEvent;
    const { count } = customEvent.detail;

    console.log('[CartIcon] Cart updated, new count:', count);

    if (this.countElement) {
      this.countElement.textContent = count.toString();
    }
  }

  protected onDestroy(): void {
    super.onDestroy();

    document.removeEventListener(EVENT_GLOBAL_UPDATE_CART, this.onUpdateCartBinding);
  }
}

export default CartIcon;
